import { render, staticRenderFns } from "./FtpIntegrationForm.vue?vue&type=template&id=633ec672&"
import script from "./FtpIntegrationForm.vue?vue&type=script&lang=js&"
export * from "./FtpIntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports